import Service from 'src/service/api-service';
import API_URL from 'src/service/api-url';
import { GRANT_TYPE } from 'src/config';

const service = new Service();

export function Token(data, grant_type = GRANT_TYPE, scope = undefined) {
  const params = {
    grant_type,
    scope,
    ...data
  };

  return service
    .post(API_URL.TOKEN, params)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
}
